import React, { Component } from "react";
import PropTypes from "prop-types";

import { StringHelper, _ } from '../../strings'

export default class Popup extends Component {

  constructor(props){
    super(props)
  }

  static propTypes = {
    visibility: PropTypes.bool
  };

  render() {

    const lang = (navigator.language || navigator.userLanguage).toLocaleLowerCase();
    let langPath = ""
    const ary = lang.split("-");
    if(ary.length == 2) {
      langPath = `/${ary[1]}`;
    } else {
      switch(lang) {
        case "ja": {
          langPath = "/jp";
          break;
        }
        case "ko": {
          langPath = "/kr";
          break;
        }
        default :{
          langPath = `/${lang}`
        }
      }
    }
  
    const appStoreLink = `https://itunes.apple.com${langPath}/app/maidwhite/id1141440323`
    let effect;
    if(this.props.visibility === null) {
      effect = "";
    } else if(this.props.visibility){
      effect = "fadeIn"
    } else {
      effect = "fadeOut"
    }
    
    return(
      <div>
      <div className="pop-up-bg" style={{visibility: this.props.visibility ? "visible" : "hidden"}} onClick={this.props.onClose}>
      
      <div className={`pop-up ${effect}`} onClick={(e) => {e.stopPropagation()}}>
        <div className="container">
          <div className="title">{_("MaidWhite")}</div>
          <div className="icon-warp">
            <div className="maidwhit-icon"/>
            <div className="download-warp">
              <div className="download-message">{_("popup_subtitle")}</div>
              <a className="apple" href={appStoreLink} target="_blank"/>
              <a className="android" href="https://play.google.com/store/apps/details?id=tw.tih.maidwhite" target="_blank"/>
            </div>
          </div>
          <div className="also-text">{_("popup_can_alse")}</div>
          <div>
          <a className="google-assistannce-warp" href="https://assistant.google.com/services/a/uid/0000000bc8cb92f7" target="_blank">
            <div className="google-assistance-icon"/>
            <div className="google-assistance-action">{_("popup_action_en")}</div>
          </a>
          <a className="google-assistannce-warp" href="https://assistant.google.com/services/a/uid/000000e3cc3e3cb1?hl=zh" target="_blank">
            <div className="google-assistance-icon"/>
            <div className="google-assistance-action">{_("popup_action_local")}</div>
          </a>
          </div>
          <div className="more-text">{_("popup_and_more")}</div>
          <div className="other-assistance-warp">
            <a className="tmall"/>
            <a className="alexa" href="https://www.amazon.com/Taiwan-Intelligent-Home-Corp-White/dp/B075SM28N6" target="_blank"/>
          </div>
          <div className="btn-close" onClick={this.props.onClose}/>
        </div>
      </div>
      </div>
      </div>
    )
  }
}